import { useState } from 'react';
import Input from '@/components/input/Input';
import Button from '@/components/Button';
import { useVoucherRedeem } from '../hooks/useVoucherRedeem';
import { useParams } from 'react-router-dom';

function RedeemForm({ setRedeemdLectures, setLecturesToRedeem, setCode }) {
    const [voucher, setVoucher] = useState('');
    const { lecture_id } = useParams();
    const { voucherRedeem, error, isPending } = useVoucherRedeem();

    function handelSubmit(e) {
        e.preventDefault();

        if (!voucher) return;
        voucherRedeem(
            { voucher, lecture_id },
            {
                onSuccess: (data) => {
                    const content = data?.data;
                    setRedeemdLectures(content);
                },
                onError: (error, value) => {
                    setCode(value.voucher);
                    setLecturesToRedeem(error.response.data.available_lectures);
                },
            }
        );
    }

    return (
        <section className="w-full max-w-4xl px-16 py-20 mx-auto">
            <Input
                label="الكود"
                name="voucher"
                defaultValue={voucher}
                onChange={(e) => setVoucher(e.target.value)}
                size="full"
                error={
                    error?.response?.data?.errors?.voucher?.[0]
                        ? 'الكود غير صحيح'
                        : error?.response.status == 422
                        ? 'الرجاء اختيار محاضرة.'
                        : error?.response?.data?.message
                }
                disabled={isPending}
            />

            <Button
                type="primary"
                disabled={isPending}
                name="submit the voucher for redeeming"
                className="w-full mt-5"
                onClick={(e) => handelSubmit(e)}
            >
                شراء
            </Button>
        </section>
    );
}

export default RedeemForm;
